import { Dispatch, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';

import { Layout } from '../../../CorePackage/MainModule/components/Layout';
import { PassportGroupForm } from '../../../PassportGroupPackage/PassportGroupFormModule/components/PassportGroupForm';
import { RootActions } from '../../../CorePackage/MainModule/types/RootActions';
import { ROUTE_KNM_MASS_CANCELLATION } from '../../../CorePackage/MainModule/routes/routes';
import { passportGroupSetNoticeAction } from '../../../PassportGroupPackage/MainModule/actions/passportGroupActions';
import { PassportGroupTypeEnum } from '../../../APIPackage/PassportGroupsModule/enums/PassportGroupTypeEnum';

export const PassportMassCancellationCreateGroupPage = () => {
  const dispatch = useDispatch<Dispatch<RootActions>>();
  const history = useHistory();
  const handleGroupCreated = useCallback(() => {
    dispatch(passportGroupSetNoticeAction('Группа успешно создана. Запущен фоновый процесс сбора паспортов группы.'));
    history.push(ROUTE_KNM_MASS_CANCELLATION);
  }, [history, dispatch]);

  const handleCancelCreate = useCallback(() => {
    history.push(ROUTE_KNM_MASS_CANCELLATION);
  }, [history]);

  return (
    <Layout withFooter>
      <PassportGroupForm
        onGroupCreated={handleGroupCreated}
        onCancelCreate={handleCancelCreate}
        groupType={PassportGroupTypeEnum.CANCELLATION}
      />
    </Layout>
  );
};
